module.exports = __webpack_public_path__ + "media/img/ararildo-0f3c0ee4.png";